import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=24ff128f&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24ff128f')) {
      api.createRecord('24ff128f', component.options)
    } else {
      api.reload('24ff128f', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=24ff128f&", function () {
      api.rerender('24ff128f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-201V27iL26AVU/JS/imageCarousel.vue"
export default component.exports